import React from 'react';
import Styles from '../components/Solucao.module.css';
import triangulo from '../img/triangulo.webp'
const Solucao1 = () => {
  return (
    <div>
      <div>
        <section className={Styles.Solucao}>
          <h2>Tudo comunica.</h2>
          <p>
            A roupa que você escolhe. O tom de voz que usa. O “bom dia” que não dá ao entrar no elevador. O atraso para
            um compromisso. A consulta que não desmarca, mesmo sabendo que não irá.
          </p>
          <p>
            A comunicação vai muito além das palavras. <span>Seu comportamento é a sua mensagem.</span> Ele define como
            as <span>pessoas te percebem, confiam (ou não) em você e te levam a sério.</span>
          </p>
        </section>
        <section className={Styles.reputacao}>
          <h2>A sua reputação te precede.</h2>
          <p>
            Antes mesmo de você se apresentar, as pessoas já formaram uma ideia sobre você - pelo que ouviram, pelo que
            viram, pelo que perceberam nas suas atitudes.{' '}
            <span>
              Não se trata de parecer confiante, mas de inspirar confiança simplesmente por viver de acordo com o que
              diz.
            </span>
          </p>
        </section>
        <section className={Styles.imagemComportamento}>
          <img src={triangulo} alt="" />
        </section>
        <section className={Styles.Azul}>
          <h2>O que é o Repertório Comportamental?</h2>
          <p>
            Não é apenas um curso sobre comportamento. <span>É uma experiência</span> que te ensina a entender e
            ajustar padrões, comunicar com clareza, fortalecer sua inteligência emocional e assumir o controle das suas decisões e prioridades.
          </p>
          <p>
            Não se trata de técnicas engessadas ou fórmulas prontas.{' '}
            <span>
              Trata-se de compreender o impacto do seu comportamento, o que você transmite e como alinhar isso ao que
              deseja comunicar.
            </span>
            
          </p>
          <p>Ao desenvolver seu repertório comportamental, você será capaz de:</p>
          <ul>
            <li>✔ Comunicar suas ideias com clareza e segurança;</li>
            <li>✔ Ser reconhecida como uma profissional de valor;</li>
            <li>✔ Se posicionar com autoridade em qualquer ambiente.</li>
          </ul>
          <h2>Tudo é comportamento.</h2>
          <p>
            Desde a infância, somos condicionadas a seguir padrões, mas esses mesmos padrões podem <span>limitar seu
            potencial</span>. Para se destacar, é preciso <span>romper essas barreiras invisíveis.</span>
          </p>

          <p>
          Se você sente que pode melhorar a forma como se expressa, se posiciona e constrói relações,<span> esse curso é para você.</span>
          </p>
          <p>O mundo lê você o tempo todo. <span> A questão é: o que a sua comunicação está dizendo?</span> </p>
        </section>
      </div>
    </div>
  );
};

export default Solucao1;
